export default "__VITE_ASSET__Cp9Aad3X__"